import type {Components, Theme} from '@mui/material/styles';

export const fabOverrides: Components<Theme>['MuiFab'] = {
    styleOverrides: {
        root: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
            },
            '&:active': {
                boxShadow: 'none',
            },
            '&:focus': {
                boxShadow: 'none',
            },
        },
    },
};
